export const ROADMAP_PILLARS = [
    { id: "growth", label: "Growth & market" },
    { id: "product", label: "Product & delivery" },
    { id: "revenue", label: "Revenue & finance" },
    { id: "operations", label: "Operations" },
    { id: "people", label: "People & culture" },
];

export const STATUSES = [
    { id: "planned", label: "Planned" },
    { id: "in_progress", label: "In progress" },
    { id: "achieved", label: "Achieved" },
    { id: "deferred", label: "Deferred" },
];

export const EFFORT_BANDS = [
    { id: "s", label: "S — days" },
    { id: "m", label: "M — weeks" },
    { id: "l", label: "L — months" },
    { id: "xl", label: "XL — quarter+" },
];

export const RISK_LEVELS = [
    { id: "low", label: "Low risk" },
    { id: "medium", label: "Medium" },
    { id: "high", label: "High risk" },
];

export const HEALTH_STATES = [
    { id: "on_track", label: "On track" },
    { id: "watch", label: "Watch" },
    { id: "blocked", label: "Blocked" },
];

/** Starter packs: applied as multiple new items with relative target dates */
export const ROADMAP_TEMPLATES = [
    {
        id: "quarterly_reset",
        name: "Quarterly planning pack",
        description: "Review, goals, and comms for a new quarter",
        items: [
            { title: "Close prior quarter — metrics & lessons", pillar: "revenue", daysFromNow: 5, effort_band: "s", risk_level: "low" },
            { title: "Draft next-quarter priorities (leadership)", pillar: "operations", daysFromNow: 10, effort_band: "m", risk_level: "medium" },
            { title: "Align roadmap to capacity & hiring", pillar: "people", daysFromNow: 14, effort_band: "m", risk_level: "medium" },
            { title: "Customer / pipeline review for forecast", pillar: "growth", daysFromNow: 12, effort_band: "s", risk_level: "low" },
            { title: "Ship quarterly comms (internal + key accounts)", pillar: "product", daysFromNow: 21, effort_band: "s", risk_level: "low" },
        ],
    },
    {
        id: "product_launch",
        name: "Product launch spine",
        description: "From beta to GA-shaped milestones",
        items: [
            { title: "Define launch criteria & rollback plan", pillar: "product", daysFromNow: 7, effort_band: "m", risk_level: "medium" },
            { title: "Security / compliance checkpoint", pillar: "operations", daysFromNow: 14, effort_band: "m", risk_level: "high" },
            { title: "Pricing & packaging sign-off", pillar: "revenue", daysFromNow: 18, effort_band: "s", risk_level: "medium" },
            { title: "Enablement: docs, demos, support brief", pillar: "people", daysFromNow: 25, effort_band: "l", risk_level: "medium" },
            { title: "Launch day run-of-show", pillar: "growth", daysFromNow: 35, effort_band: "s", risk_level: "high" },
        ],
    },
    {
        id: "revenue_growth",
        name: "Revenue acceleration",
        description: "Pipeline, retention, and expansion hooks",
        items: [
            { title: "Win/loss analysis — last 90 days", pillar: "growth", daysFromNow: 7, effort_band: "s", risk_level: "low" },
            { title: "Expansion playbook for top accounts", pillar: "revenue", daysFromNow: 14, effort_band: "m", risk_level: "medium" },
            { title: "Reduce churn: top 3 hypotheses & tests", pillar: "product", daysFromNow: 21, effort_band: "l", risk_level: "high" },
            { title: "Rev ops: forecast model refresh", pillar: "revenue", daysFromNow: 28, effort_band: "m", risk_level: "medium" },
        ],
    },
];
